import * as SG from '../style/Styles'
import Footer from '../components/Footer'
import InfosRegulation from '../components/InfosRegulation'
import * as U from './../util/UrlHttp'
import * as TXT from './../util/Texts'
import IconFlagSelector from '../components/IconFlagSelector'

export default function Regulament() {

    return (
        <SG.Div className='containerRefg'>
            
            <SG.CenterItem style={{marginTop:20}}> 
                <IconFlagSelector />
            </SG.CenterItem>

            <InfosRegulation />
           
            <Footer />
        </SG.Div>
    );
}
  